import { render } from "./button-switcher.vue?vue&type=template&id=663d56fc&scoped=true&lang=html"
import script from "./button-switcher.vue?vue&type=script&lang=js"
export * from "./button-switcher.vue?vue&type=script&lang=js"

import "./button-switcher.vue?vue&type=style&index=0&id=663d56fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663d56fc"]])

export default __exports__